import { readCookie } from '../components/common/Cookie';
import { readQueryParameter } from './pageInfo';
import properties from '../modules/ajio-util/properties';
import isNode from '../modules/ajio-util/isNode';
import _isEmpty from 'lodash/isEmpty';

// Subdomain logic for SIS
export function getHostName(Host = '', query = {}, shouldReturnRush = false) {
  if (
    Host != '' &&
    (Host.toLowerCase().includes('ajio.com') ||
      Host.toLowerCase().includes('ril.com') ||
      Host.toLowerCase().includes('web.ajio.com') ||
      Host.toLowerCase().includes('localhost') ||
      Host.toLowerCase().includes('jio.com'))
  ) {
    let storeValue = '';
    storeValue = Host.replace(
      /(http(s){0,1}:\/\/)*((w){3,}.)*([a-z]*[0-9]{0,}-)*((.web){0,}(.services){0,}(.ajio){0,}(.jio){0,}(.ril){0,}.com(.*)){0,}/gi,
      ''
    );
    storeValue = storeValue.split('.')[0];

    //! This is temp changes for fleek to testing on valuestore, this has to be changed
    //storeValue.toLowerCase().includes('valuestore')
    // if(storeValue.toLowerCase().includes(FLEEK_STORE)){
    //   return FLEEK_STORE; // trends
    // }
    // this is the condition for preview
    if (
      storeValue.includes('preview') ||
      storeValue.includes('uat') ||
      storeValue.includes('qa') ||
      storeValue.includes('sit') ||
      storeValue.includes('localhost')
    ) {
      if (isNode() && query.store && query.isPreview) {
        return query.store.toLowerCase();
      }
      if (window?.location) {
        const queryParams = readQueryParameter(window.location);
        if (queryParams?.store && queryParams?.isPreview) {
          return queryParams.store.toLowerCase();
        }
      }
    }
    // this the condition to set the store name for the prod env
    // as if the env is any other then prod then storeValue is returned from this
    if (
      storeValue &&
      !storeValue.includes('localhost') &&
      storeValue.toLowerCase() != 'ajio' &&
      !storeValue.toLowerCase().startsWith('uat') &&
      !storeValue.toLowerCase().startsWith('qa') &&
      !storeValue.toLowerCase().startsWith('sit') &&
      !storeValue.toLowerCase().startsWith('preprod') &&
      !storeValue.toLowerCase().startsWith('island') &&
      !storeValue.toLowerCase().startsWith('preview')
    ) {
      return !shouldReturnRush && storeValue.toLowerCase() === 'rush' ? 'ajio' : storeValue;
    }
    return '';
  }
  return ''; // trends
}

// Rush store is identified by the subdomain, e.g. rush.ajio.com, qa-rush.services.ajio.com
export function isRushStore(host = '', query = {}) {
  const hostValue = host || (typeof window !== 'undefined' ? window?.location?.origin || '' : '');
  if (!hostValue) return false;
  return getHostName(hostValue, query, true).toLowerCase() === 'rush';
}

export function numberValidator(val) {
  const reg = new RegExp('^\\d+$');
  return reg.test(val);
}

export function alphanumericValidator(val) {
  return val.replace(/[^a-z0-9]+/gi, '');
}

export function isValidCSAId(val = '') {
  return val && numberValidator(val) && val.length == 8;
}

export const topSearches = [
  { url: 'shoes', value: 'shoes' },
  { url: 'jackets', value: 'jackets' },
  { url: 'jeans', value: 'jeans' },
  { url: 'kurti', value: 'kurti' },
  { url: 'joggers', value: 'joggers' },
  { url: 'top', value: 'top' },
  { url: 'boots', value: 'boots' },
  { url: 'sneaker', value: 'sneaker' },
  { url: 'heels', value: 'heels' }
];

export const getStoreInformation = (childStores=[], currentStore='') => {
  if(childStores.includes(currentStore) || _isEmpty(currentStore)) {
    return 'ajio'
  } else {
    return currentStore;
  }
};